import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import HeaderNew from "../../../old/Components/Organisms/HeaderNew";
import Footer from "../../../old/Components/Organisms/Footer";
import * as ST from "./styled";
import NavigationFixedBar from "../../../old/Components/Atoms/NavigationFixedBar";
import { navbarData } from "../../../old/Components/Atoms/NavigationFixedBar/NavbarData";
import BreadcrumbsMenu from "src/old/Components/Atoms/BreadCrumbsMenu";
import {BreadcrumbsProvider} from "../../../old/Components/Atoms/BreadCrumbsMenu/BreadcrumbsContext";

const GeneralLayout: FC = () => {
	return (
		<>
			<BreadcrumbsProvider>
				<HeaderNew />
				<ST.BreadMenuContainer>
					<BreadcrumbsMenu />
				</ST.BreadMenuContainer>
				<ST.MainLayout id="Main-layout">
					<ST.Content>
						<Outlet />
					</ST.Content>
				</ST.MainLayout>
				<Footer />
				<NavigationFixedBar navbarItems={navbarData} />
			</BreadcrumbsProvider>
		</>
	);
};

export default GeneralLayout;
